// extracted by mini-css-extract-plugin
export default {"container":"comment_container__Rj1uC"};